<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-date-picker style="float: left;"
          v-model="startDate"
          type="date"
          placeholder="请选择开始日期">
        </el-date-picker>
        <el-date-picker style="float: left;"
          v-model="endDate"
          type="date"
          placeholder="请选择截止日期">
        </el-date-picker>
        <el-select placeholder="请选择订单状态" v-model="state" style="float: left;">
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
        <el-input v-model="keywords" placeholder="请输入关键字" style="float: left;"></el-input>
        <el-button @click="_getList" type="primary" style="float: left;">搜索</el-button>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow">
        </el-pagination>
      </div>
      <div class="userTable">
        <el-table
        ref="multipleTable"
        :data="productDatas"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange">
        <!-- <el-table-column
          type="selection"
          width="60">
        </el-table-column> -->
       <el-table-column
          prop="orderNumber"
          label="订单编号"
          width="200">
        </el-table-column>
        <el-table-column
          prop="orderAmountTotal"
          label="总价格"
          width="100">
        </el-table-column>
        <el-table-column
          prop="uvalue"
          label="产生Q值"
          width="100">
        </el-table-column>
        <el-table-column
          prop="orderShippingVo.contactName"
          label="收货人"
          width="100">
        </el-table-column>
        <el-table-column
          prop="orderShippingVo.contactPhone"
          label="联系方式"
          width="120">
        </el-table-column>
        <el-table-column
          prop="orderShippingVo"
          :formatter="handleAddressValue"
          label="收货地址"
          width="300">
        </el-table-column>
        <el-table-column
          prop="getType"
          :formatter="handleDeliveryValue"
          label="配送方式"
          width="100">
        </el-table-column>
        <el-table-column
          prop="insertTime"
          label="下单时间"
          width="200">
        </el-table-column>
       <el-table-column
         prop="status"
         :formatter="handleStatusValue"
         label="订单状态"
         width="100">
        </el-table-column>
        <el-table-column label="操作"
          show-overflow-tooltip>
           <template slot-scope="scope">
             <el-button
               size="mini"
               @click="handleDispatch(scope.row)" v-if="scope.row.status==1">发货</el-button>
           </template>
         </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="发货物流填写"
        :visible.sync="dispatchVisible"
        width="30%"
        center
        :append-to-body=true>
        <el-form :label-position="left" label-width="100px" :model="controlData" :rules="rules" ref="addForm">
          <el-form-item label="物流">
            <el-select v-model="controlData.logisticsCompanyId">
              <el-option
                v-for="item in logisticsOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="logisticsNumber">
            <el-input v-model="controlData.logisticsNumber"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dispatchVisible = false">取 消</el-button>
          <el-button type="primary" @click="dispatch">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getAllOrders, dispatch, getLogistics} from 'api/request'
import {ERR_OK} from 'api/config'
import {formatDate, loadingInstance, Success, Error} from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      token:window.localStorage.getItem("token"),
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      state: null,
      startDate: null,
      endDate: null,
      ca: null,
      //101：待支付  301：待发货  302：待收货  1：已完成  450：退换/售后
      stateOptions:[{
        value: '101',
        label: '待支付'
      }, {
        value: '301',
        label: '待发货'
      }, {
        value: '302',
        label: '待收货'
      }, {
        value: '1',
        label: '已完成'
      }, {
        value: '450',
        label: '退换/售后'
      }],
      logisticsOptions:[],
      supplierId: null,
      categoryId: null,
      keywords: null,
      dispatchVisible: false,
      deleteDialogVisible: false,
      detailDialogVisible: false,
      left: "left",
      addData: {},
      controlData: {},
      roundDatas: [],
      productDatas: [],
      multipleSelection: [],
      fileList: [],
      fileList1: [],
      fileyHeader: {},
      fileData: {
        type:1
      },
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this.fileyHeader ={
        token:getUserInfo.token,
        'Content-Type': 'application/json;charset=utf-8'
      }
      this._getList();
      this._getLogistics();
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChange (val) {
      console.log(val)
      this.pageNum = val
      this._getList()
    },
    handleStatusValue(row, column, cellValue, index) {
      //-1取消支付   -2订单超时未支付
      switch(cellValue){
        case 0:
          return "待支付"
        case 1:
          return "待发货"
        case 2:
          return "已发货"
        case 3:
          return "已收货"
        case 4:
          return "已评价"
        case -1:
          return "取消支付"
        case -2:
          return "订单超时未支付"
      }
    },
    handleDeliveryValue(row, column, cellValue, index) {
      //配送方式  1.物流   2.用户自提
      switch(cellValue){
        case 1:
          return "物流"
        case 2:
          return "用户自提"
      }
    },
    handleAddressValue(row, column, cellValue, index) {
      return cellValue.province+cellValue.city+cellValue.county+cellValue.detailed
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.productDatas[index];
    },
    handleDispatch(row) {
      this.dispatchVisible = true;
      this.controlData.itemNumber = row.orderNumber;
    },
    dispatch() {
      let param = {
        itemNumber: this.controlData.itemNumber,
        logisticsCompanyId: this.controlData.logisticsCompanyId,
        logisticsNumber: this.controlData.logisticsNumber
      }
      loadingInstance(Loading);
      dispatch(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          Success(this, res);
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    handleEdit(index, row) {
      window.localStorage.setItem('productId',row.id);
      this.$router.push({
        path: '/addProduct'
      })
    },
    handleRemove(file, fileList) {
       console.log(file, fileList);
    },
    handleRemove1(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    _deleteProduct(){
      let param = {
        id: this.controlData.id,
      }
      loadingInstance(Loading);
      deleteProduct(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.deleteDialogVisible = false;
          this._getList ();
        } else {
          Error(this, res);
        }
      })
    },
    _getLogistics () {
      let param = {
        current: this.pageNum,
        size: 100
      }
      loadingInstance(Loading)
      getLogistics(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.logisticsOptions = res.data
        } else {
          Error(this, res)
        }
      })
    },
    _getList () {
      let param = {
        state: this.state,
        startDate: this.startDate,
        endDate: this.endDate,
        content: this.keywords,
        current: this.pageNum,
        size: this.pageSize
      }
      loadingInstance(Loading)
      getAllOrders(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.productDatas = res.data.records
          this.totalNum = res.data.total
          if(res.data.pages>1){
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    }
  },
}
</script>
<style scoped>
    .user{
      z-index: 9;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #F8F8F8;
    }
   .userOperate{
     height: 50px;
     margin-left: 10px;
     margin-right: 10px;
     margin-top: 30px;
     margin-bottom: 10px;
     box-sizing: border-box;
   }
   .userTable{
     padding: 10px;
     position: relative;
   }
</style>
<style>
  .userOperate .el-input {
    width:180px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }
  .userOperate .el-button {
    width:100px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/newOrder.vue